import React from 'react';
import { makeStyles, Tooltip } from '@material-ui/core';
import { COLORS } from './data';

const useStyles = makeStyles(() => ({
  panel: {
    background: 'white',
    borderRadius: 14,
    border: '1px solid rgba(0,0,0,0.06)',
    overflow: 'hidden',
  },
  header: {
    padding: '14px 16px 11px',
    borderBottom: `1px solid ${COLORS.mist}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: { fontSize: 13.5, fontWeight: 700, color: COLORS.ink },
  chartWrap: { padding: '14px 16px' },
  bars: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 5,
    height: 156,
    paddingTop: 12,
    marginBottom: 7,
    boxSizing: 'border-box',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    gap: 3,
  },
  bar: {
    width: '100%',
    borderRadius: '3px 3px 0 0',
    minHeight: 4,
    cursor: 'default',
  },
  barPrev: { background: `linear-gradient(180deg,${COLORS.blue},${COLORS.blueDk})` },
  barCurr: { background: `linear-gradient(180deg,${COLORS.orange},#D96A10)` },
  day: { fontSize: 9.5, color: COLORS.slate, fontWeight: 500 },
  dayToday: { color: COLORS.orange, fontWeight: 700 },
  legend: { display: 'flex', gap: 12 },
  leg: {
    display: 'flex', alignItems: 'center', gap: 5, fontSize: 11, color: COLORS.slate,
  },
  dot: { width: 8, height: 8, borderRadius: 2 },
}));

const CHART_HEIGHT = 144;

const formatCLP = (n) => `$${Number(n).toLocaleString('es-CL')}`;

export default function WeeklyChartPanel({ dias }) {
  const classes = useStyles();
  const maxAmount = Math.max(...dias.map((d) => d.amount), 1);

  return (
    <div className={classes.panel}>
      <div className={classes.header}>
        <span className={classes.title}>Ventas esta semana</span>
      </div>
      <div className={classes.chartWrap}>
        <div className={classes.bars}>
          {dias.map((d) => (
            <div key={d.day} className={classes.col}>
              <Tooltip title={formatCLP(d.amount)} placement="top" arrow>
                <div
                  className={`${classes.bar} ${d.isToday ? classes.barCurr : classes.barPrev}`}
                  style={{ height: Math.round((d.amount / maxAmount) * CHART_HEIGHT) }}
                />
              </Tooltip>
              <span className={`${classes.day} ${d.isToday ? classes.dayToday : ''}`}>
                {d.day}
              </span>
            </div>
          ))}
        </div>
        <div className={classes.legend}>
          <div className={classes.leg}>
            <div className={classes.dot} style={{ background: COLORS.blue }} />
            Días anteriores
          </div>
          <div className={classes.leg}>
            <div className={classes.dot} style={{ background: COLORS.orange }} />
            Hoy
          </div>
        </div>
      </div>
    </div>
  );
}
